<template>
  <CustomTable
    ref="customTableRef"
    :columns="columnsToPlatform"
    :openModal="handleOpen"
    type="Platform"
  />
</template>

<script setup>
import { useStore } from 'vuex'

const store = useStore()
import CustomTable from './CustomTable.vue'
import { columnsToPlatform } from '@/components/PatientFile/ModalBody/todo/config'
import { computed, ref } from 'vue'
import { postCloseEnd, postPinOfficial } from '@/api/patientFile'
import { message } from 'ant-design-vue'

const info = computed(() => store.state.patientFile.info)
const customTableRef = ref(null)

const handleOpen = data => {
  const { platformType } = data.record
  const request = platformType === 3 ? postCloseEnd : postPinOfficial
  request({ ucPatientId: info.value.ucPatientId }).then(res => {
    if (res) {
      message.success('操作成功')
      // 操作成功后刷新表格
      customTableRef.value?.refreshTable()
    }
  })
}
</script>

<style lang="scss" scoped></style>
